import { createSelector } from "reselect"
import { initialState } from "./reducer"

/**
 * Direct selector to the ActionPlansImport state domain
 */

const selectActionPlansImportDomain = (state) =>
  state.get("actionPlansImport", initialState)

/**
 * Other specific selectors
 */
export const makeSelectIsDownloading = () =>
  createSelector(selectActionPlansImportDomain, (state) =>
    state.get("isDownloading")
  )

const makeSelectActionPlansImport = () =>
  createSelector(selectActionPlansImportDomain, (substate) => substate.toJS())

export default makeSelectActionPlansImport
export { selectActionPlansImportDomain }
